// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ChartTabs_tabs__Q838_","tab_item":"ChartTabs_tab_item__wNg33","tab_selected":"ChartTabs_tab_selected__EAlwI","tab_disabled":"ChartTabs_tab_disabled__4Jtee"};